export const styles = theme => ({
  root: {
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center',
    },
  },

  icon: {
    color: theme.palette.primary.main,
    display: 'block',
    marginBottom: theme.spacing(0.5),
    margin: theme.spacing(2, 4),
    '&:hover': {
      color: theme.palette.primary.dark,
    },
  },

  iconLabel: {
    textAlign: 'center',
    fontWeight: 300,
    marginBottom: theme.spacing(1),
  },

  xsIcon: {
    [theme.breakpoints.down('xs')]: {
      // width: 15,
      // height: 15,
      margin: theme.spacing(1, 3),
    },
  },

  xsIconLabel: {
    [theme.breakpoints.down('xs')]: {
      fontSize: 12,
    },
  },
})
